<template>
  <div>
    <LoadingWidget v-if="loading" />

    <template v-else>
      <v-sheet class="py-6 py-md-8 px-3" color="primary">
        <TitleWidget v-if="title" :small="xsOnly" dark>
          {{ title }}
        </TitleWidget>
      </v-sheet>

      <v-container
        class="
          pt-6 pt-md-8
          pb-10 pb-md-13 pb-lg-16
          overflow-hidden
          container-large
        "
      >
        <template v-if="attachments.length || gallery.length || item.text">
          <v-row>
            <v-col cols="12" lg="9">
              <v-card elevation="0">
                <v-tabs
                  :show-arrows="smAndDown"
                  center-active
                  :vertical="!smAndDown"
                >
                  <v-tab class="justify-start">
                    <v-icon left> fa-solid fa-graduation-cap </v-icon>
                    Sobre o curso
                  </v-tab>
                  <v-tab v-if="item.text2" class="justify-start">
                    <v-icon left> fa fa-user </v-icon>
                    Corpo Docente
                  </v-tab>
                  <v-tab v-if="item.text3" class="justify-start">
                    <v-icon left> fa-list </v-icon>
                    Periódicos
                  </v-tab>
                  <v-tab v-if="attachments.length" class="justify-start">
                    <v-icon left> fa-solid fa-graduation-cap </v-icon>
                    Matriz Curricular
                  </v-tab>
                  <v-tab v-if="attachments2.length" class="justify-start">
                    <v-icon left> fa-solid fa-book </v-icon>
                    Regulamentos
                  </v-tab>
                  <v-tab v-if="attachments3.length" class="justify-start">
                    <v-icon left> fa-regular fa-clock </v-icon>
                    Horário
                  </v-tab>
                  <v-tab-item>
                    <v-card flat>
                      <v-card-text>
                        <div
                          v-if="item.text"
                          class="
                            grey--text
                            text-body-1
                            font-weight-regular
                            ck-content
                          "
                          v-html="item.text"
                        ></div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item v-if="item.text2">
                    <v-card flat>
                      <v-card-text>
                        <div
                          class="
                            grey--text
                            text-body-1
                            font-weight-regular
                            ck-content
                          "
                          v-html="item.text2"
                        ></div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item v-if="item.text3">
                    <v-card flat>
                      <v-card-text>
                        <div
                          class="
                            grey--text
                            text-body-1
                            font-weight-regular
                            ck-content
                          "
                          v-html="item.text3"
                        ></div>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item v-if="attachments">
                    <v-card flat>
                      <v-card-text>
                        <AttachmentSection
                          v-if="attachments.length"
                          :align="'left'"
                          :has-title="!!item.text"
                          :items="attachments"
                        />
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item v-if="attachments2">
                    <v-card flat>
                      <v-card-text>
                        <AttachmentSection
                          v-if="attachments2.length"
                          :align="'left'"
                          :has-title="!!item.text"
                          :items="attachments2"
                        />
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item v-if="attachments3">
                    <v-card flat>
                      <v-card-text>
                        <AttachmentSection
                          v-if="attachments3.length"
                          :align="'left'"
                          :has-title="!!item.text"
                          :items="attachments3"
                        />
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </v-card>
            </v-col>
            <v-col cols="12" lg="3">
              <img
                v-if="image && item.text"
                class="d-block mb-6 item-img"
                :src="files + image + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
                :alt="title"
                width="100%"
              />

              <img
                v-if="icon"
                class="d-block mb-6 item-img"
                :src="files + icon + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
                :alt="title"
                width="100%"
              />

              <v-card>
                <v-card-text>
                  <TitleWidget class="mb-4">Fale conosco</TitleWidget>
                  <ContactForm></ContactForm>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <ArticlesSection :course-id="courseId"></ArticlesSection>
          <GalleriesSection :course-id="courseId"></GalleriesSection>
        </template>

        <v-alert v-else type="info">{{ noContentText }}</v-alert>
      </v-container>
    </template>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import AttachmentSection from "../components/sections/AttachmentSection.vue";
import ArticlesSection from "../components/sections/ArticlesSection.vue";
import GalleriesSection from "../components/sections/GalleriesSection.vue";
import ContactForm from "../components/forms/ContactForm.vue";
import { formatToURL } from "../utils/formatToURL";

const _data = {
  loading: true,
  noContentText: "Nenhum conteúdo adicionado até o momento, volte mais tarde.",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    mod() {
      return this.$route.meta.mod;
    },
    itemId() {
      return this.$route.params.item;
    },
    item() {
      return this.$rest(this.mod)
        .list.filter(({ title }) => formatToURL(title) === this.itemId)
        .pop();
    },
    courseId() {
      return this.item.id;
    },
    title() {
      return this.item.title;
    },
    icon() {
      return this.item?.icon;
    },
    image() {
      return this.item?.img?.featured || "";
    },
    attachments() {
      if (this.item?.attachments?.length) return this.item.attachments;

      return [];
    },
    attachments2() {
      if (this.item?.attachments2?.length) return this.item.attachments2;

      return [];
    },
    attachments3() {
      if (this.item?.attachments3?.length) return this.item.attachments3;

      return [];
    },
    gallery() {
      if (this.item?.img?.list.length)
        return this.item.img.list.map(({ path, title }) => ({
          src: this.files + path,
          caption: title,
        }));

      return [];
    },
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  watch: {
    item() {
      document.title = `${this.title} | ${this.name}`;
    },
  },
  created() {
    this.$rest(this.mod)
      .get()
      .finally(() => (this.loading = false));
  },
  components: {
    LoadingWidget,
    TitleWidget,
    AttachmentSection,
    GalleriesSection,
    ArticlesSection,
    ContactForm,
  },
};
</script>

<style lang="scss" scoped>
.item-img {
  max-height: 60vh;
  max-width: 100%;
  object-fit: contain;
}
</style>
